import React from "react";
import { useLocation } from "react-router-dom";
import LottieLoader from "./LottieLoader"; // adjust import if path is different

const LottieLoaderPage = () => {
  const location = useLocation();
  const {
    boardWidth = 300,
    message = "Wait_for_analyzing",
    lottieUrl = "https://res.cloudinary.com/dnlgtek2a/raw/upload/v1743418492/Lottie/analysis.json",
  } = location.state || {};

  return (
    <LottieLoader
      loading={true}
      boardWidth={boardWidth}
      message={message}
      lottieUrl={lottieUrl}
    />
  );
};

export default LottieLoaderPage;
